import { useEffect, useState } from 'react';
import './Pyschometric.css';
import { ReceiveQuestions } from '../../services/PyschometricQuestions';
import { useNavigate } from 'react-router-dom';

function Instruction({agreementSign})
{

    const [agreementSignCheck,setAgreementSign]=useState(false);
    
    const [testStatus,setTestStatus]=useState(false);

    const navigate=useNavigate();
    const checkForTestCompletion=async()=>{
      const questions=await ReceiveQuestions();
        
      if(questions && questions.success && questions?.completed===true)
        {
          setTestStatus(true);
          return;
        } 

    }
     const handleNext=()=>{
          if(agreementSignCheck)
          { 
            if(testStatus==true)
              {
                navigate('/pyschometrictest/questions/score');
                return;
              }
             agreementSign(true);
          }
        else
           agreementSign(false);
     }
     useEffect(()=>{
      checkForTestCompletion();
     },[]);
    return(
    <>
      <div className='pyschometrictestcontainer'>
      <section className='pyschometrictext'>
            <h2>Pyschometric Test</h2>
            <h4><span >Home</span><span > &gt; Pyschometric Test</span><span style={{color:'#8A090D'}}>&gt; Instruction</span> </h4>
         </section>
         <section className='contextpanel'>
            <h2>Instructions and way to submit</h2>
            <span>
            <h3>1. Read and Accept Terms and Conditions:</h3>
            <h4>Before starting the assessment, please review and accept the Terms and Conditions provided.</h4>
          </span>
          <span>
            <h3>2. Enable Video Camera</h3>
            <h4>Before starting the assessment, please review and accept the Terms and Conditions provided.</h4>
          </span>
          <span>
            <h3>3. Interactive Questions with AI Support:</h3>
            <h4>
            <span>
             a. Questions will appear on your screen one at a time.
              <br />
             b. The AI will engage with you, providing assistance as you progress through each question.
              </span>
            </h4>
          </span>
          <span>
            <h3>4. Speech-to-Text Feature:</h3>
            <h4>Before starting the assessment, please review and accept the Terms and Conditions provided.</h4>
          </span>
          <span>
            <h3>5. Submit Each Answer:</h3>
            <h4>
                <span>
              a. Once you’re satisfied with your response, click the Submit button to record your answer.
              <br />
              b. You can only submit each answer once, so ensure your response is complete before submitting.
              </span>
            </h4>
            
          </span>
          <span>
            <h3>6.</h3>
            <h4>
                <span>
              a. Users will not be able to go back to previous questions.
              <br />
              b. There is no negative marking, please answer all the questions.
              </span>
            </h4>
            
          </span>
         </section>
        <div className='buttonsection'>
            <span>
                <input type='checkbox' onChange={(e)=>{setAgreementSign(e.target.checked)}}/>
                <label>I have read and accept the Terms and Conditions provided.</label>
            </span>
          <button onClick={()=>handleNext()}>Next</button>
        </div>
      </div>
    </>);
}

export default Instruction;